import { AbsgArrayHelper } from '@absg/angular-common';

export class InventoryLotHelper {

  static removeSpaceForId(id: string): string {
    // to Handle the Space the Lot Number , as Lotnumber is appended to the Id field on Form.
    if (!AbsgArrayHelper.isNil(id) && id !== '') {
      return id.replace(' ', '-');
    }
  }
}
